import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactComponent } from '../contact.component';
import { PopupService } from 'src/app/core/services/popup/popup.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-contact-popup',
    template: '',
    standalone: false
})

export class ContactPopupComponent implements OnInit {

  constructor(private popupService: PopupService, private router: Router) { }

  ngOnInit(): void {
    this.router.navigate(['/home']).then(() => {
      const ref = this.popupService.openDialog(ContactComponent);
    });
  }

}
